// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1828":"a9be7477","3500":"a1bd2805","8047":"a1bd2805","8120":"e872979c","8688":"e9dddf72"}[chunkId] + ".chunk.css";
};